import React from 'react'

export function renderLoadingSkeleton() {
  return (
    <div className="dummy-grid--content w-100">
      <div />
    </div>
  )
}

export function getFileName(filePath) {
  return filePath.replace(/^.*[\\\/]/, '')
}

export function getFormattedFilePath(filePath) {
  return `Home / ${filePath.replace(/[\\\/]/g, ' / ')}`
}

export function truncateLongFileName(longFileName) {
  if (longFileName.length > 30) return longFileName.substr(0, 30) + '...'
  return longFileName
}

export function renderLongFileName(longFileName, displayTooltip) {
  if (displayTooltip === undefined) displayTooltip = longFileName.length > 80
  return (
    <div
      className={`tooltip fileHistoryTooltip ${displayTooltip &&
        'cursor-pointer'}`}
    >
      <div className="tooltiplabel">{longFileName}</div>
      {displayTooltip && <span className="tooltiptext">{longFileName}</span>}
    </div>
  )
}

export default {
  getFileName,
  renderLongFileName,
  getFormattedFilePath,
  truncateLongFileName,
  renderLoadingSkeleton,
}
